import { getWindow } from '@jira/ssr__browser-globals/src/getWindow.tsx';

export const getRouterResourceMetrics = (): {
	ssrRouterResourceTimeouts: string[];
} => {
	const spaState = getWindow()?.SPA_STATE;
	const ssrRouterResourceTimeouts = spaState
		? Object.keys(spaState).filter((key) => {
				if (key !== key.toUpperCase()) {
					return false;
				}

				const resource = spaState[key];
				if (typeof resource !== 'object') {
					return false;
				}

				const resourceResponse = resource[Object.keys(resource)[0]];
				return resourceResponse?.error?.name === 'TimeoutError';
			})
		: [];

	return { ssrRouterResourceTimeouts };
};
